import axiosClient from "api/axios_client.js";

const BASE = "/reminder-builder/reminder-setup/source-field";

// tbl_rem_source_field. Write calls (and distinct values, which read live data) are Super Admin only.
// The source picker and the source itself come from ../api.js.
const apiReminderSourceField = {
  create:            (payload)              => axiosClient.post(`${BASE}/create`, payload),
  update:            (id, payload)          => axiosClient.put(`${BASE}/update/${id}`, payload),
  // { source_fid, searchText?, search?, sortBy?, sortOrder?, limit? }: every field of one source (at most 300).
  getAll:            (payload)              => axiosClient.post(`${BASE}/get-all`, payload),
  getById:           (id)                   => axiosClient.get(`${BASE}/get-by-id/${id}`),
  delete:            (ids)                  => axiosClient.delete(`${BASE}/delete`, { data: { ids } }),
  // Save changes of the grid: [{ id, label?, field_role?, ... }] of one source, saved together.
  bulkUpdate:        (fields)               => axiosClient.put(`${BASE}/bulk-update`, { fields }),
  // Up to 50 distinct values of a root text / number column (to fill a field's values).
  getDistinctValues: (sourceFid, fieldKey)  => axiosClient.post(`${BASE}/get-distinct-values`, { source_fid: sourceFid, field_key: fieldKey }),
};

export default apiReminderSourceField;
